import { useInstance } from '@meraki-internal/react-dependency-injection';
import React from 'react';
import { Button } from '../../components/button/Button';
import { CloudsIcon, DewpointIcon, RainAmountIcon, RaindropIcon, SnowAmountIcon, SnowflakeIcon, TemperatureIcon, VisibilityIcon, WindDirectionIcon, WindGustsIcon } from '../../components/icons/Icons';
import { WindLabel, getHeading } from '../components/WindLabel';
import { IHourlyForecast } from '../model/IHourlyForecast';
import { HourlyWeatherChartPageViewModel } from './HourlyWeatherChartPageViewModel';

const ChartMetric: React.FC<{icon: any, iconRotation?: number, value: any, units?: string, label: string, active?: boolean}> = ({ icon: Icon, iconRotation = 0, label, value, units, active }) => {
    const fill = active ? undefined : 'outline';
    const color = active ? 'primary' : 'light';
    const textColor = active ? 'light' : 'medium';
    const iconVariant = active ? 'inverse' : 'filled';

    const vm = useInstance(HourlyWeatherChartPageViewModel);

    return (
        <div style={{padding: 5, width: '50%'}}>
            {/* TODO: uintuitive that label is more like a code (not user facing, but it is, revisit when we add support for changing the chart to the metric (make the code strongly typed)) */}
            <Button size="large" expand="block" fill={fill} color={color} onClick={() => vm.changeMetric(label)}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginLeft: -20, gap: 10}}>
                    <div>
                        <Icon variant={iconVariant} size="large" rotationDegrees={iconRotation} />
                    </div>
                    <div style={{fontSize: '85%', color: `var(--ion-color-${textColor})`, display: 'flex', flexDirection: 'column', alignItems: 'start', flexGrow: 1}}>
                        <span>
                            <b>{value}</b>
                            {units ? <span style={{fontWeight: 'bold', fontSize: 'smaller'}}>{units}</span> : ''}
                        </span>
                        <small>{label}</small>
                    </div>
                </div>
            </Button>
        </div>
    );
};

export const ChartMetrics: React.FC<{forecast: IHourlyForecast}> = ({ forecast }) => {
    return (
        <div style={{display: 'flex', flexWrap: 'wrap'}}>
            <ChartMetric label="temperature" value={<>{forecast.temperatureF}&deg;</>} icon={TemperatureIcon} active />
            <ChartMetric label="dewpoint" value={<>{forecast.temperatureDewPointF}&deg;</>} icon={DewpointIcon} />
            <ChartMetric label="precip" value={`${forecast.precipitationChancePct}`} units='%' icon={forecast.precipitationType === 'snow' ? SnowflakeIcon : RaindropIcon} />
            <ChartMetric label="precip" value={`${forecast.precipitationAmountInches}`} units=' in' icon={forecast.precipitationType === 'snow' ? SnowAmountIcon : RainAmountIcon} />
            <ChartMetric
                label={`${getHeading(forecast.windDirection)} wind`}
                value={
                    <WindLabel direction={forecast.windDirection} speedMph={forecast.windSpeedMph} showUnits={false} />
                }
                units=" mph"
                icon={WindDirectionIcon}
                iconRotation={forecast.windDirection} />
            <ChartMetric label="gusts" value={`${forecast.windGustMph}`} units=' mph' icon={WindGustsIcon} />
            <ChartMetric label="clouds" value={`${forecast.cloudCoverPct}`} units='%' icon={CloudsIcon} />
            <ChartMetric label="visibility" value={`${forecast.visibilityMiles}`} units=' mi' icon={VisibilityIcon} />
        </div>
    );
};
